import { render, staticRenderFns } from "./constituentsRank.vue?vue&type=template&id=6b1e9fd3&scoped=true"
import script from "./constituentsRank.vue?vue&type=script&lang=js"
export * from "./constituentsRank.vue?vue&type=script&lang=js"
import style0 from "./constituentsRank.vue?vue&type=style&index=0&id=6b1e9fd3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1e9fd3",
  null
  
)

export default component.exports